import leftpad from "./left-pad";

export default function getISODateFromTicks(ticks) {
	const d = new Date(parseInt(ticks));
	const year = d.getFullYear();
	const month = d.getMonth() + 1;
	const day = d.getDate();
	const hour = leftpad(d.getHours(), 2);
	const minutes = leftpad(d.getMinutes(), 2);
	const seconds = leftpad(d.getSeconds(), 2);
	return `${year}/${month}/${day} ${hour}:${minutes}:${seconds}`;
}



// WEBPACK FOOTER //
// ./src/utils/get-ISO-date-from-ticks.js